import analyticsUtils from '../analytics-utils'

const productImpressions = (products, list) => {
  analyticsUtils.gaTagTracking({
    event: analyticsUtils.events.PRODUCT_IMPRESSION,
    ecommerce: {
      currencyCode: 'AUD',
      impressions: products.map((product, index) => ({
        name: product.name,
        id: product.objectId,
        category: product.primaryCategory,
        brand: product.brand,
        postion: index + 1,
        price: (product.salePrice || product.price) / 100,
        list,
        dimension79: product.retailer.retailerCode,
        dimension87: product.retailer.name,
      })),
    },
  })
}

export default productImpressions
